module.exports = __webpack_public_path__ + "static/img/broom.bd64a77.gif";


//////////////////
// WEBPACK FOOTER
// ./static/broom.gif
// module id = 42Zu
// module chunks = 1